import React, { useContext, useEffect, useRef, useState } from "react";
import "./ordersManagement.css";
import { NavBar } from "../../../../components/NavBar/NavBar";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearActiveTab } from "../../../../redux/features/TabsManager/tabSlice";
import Input from "../../../../components/Inputs/Input";
import { Sorting } from "../../../../components/Lists/Sorting";
import { OrderCards } from "./OrdersCards/OrderCards";
import Dropdowns from "../../../../components/Dropdowns/Dropdowns";
import { dropdownConfig } from "../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Link,
  Popover,
  Tooltip,
} from "@mui/material";
import { DateRangeComponent } from "../../../../components/DateRangeComponent/DateRangeComponent";
import { getApprovalPriceRanges, getOrdersList } from "../../Services/ordersServices";
import { environment } from "../../../../environments/environment";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext";
import { ResultsNotFound } from "../../../../components/ResultsNotFound/ResultsNotFound";
import { OrderManagementContext, OrderManagementProvider } from "../../context/OrderManagementContext";
import { localStorageGet, localStorageRemove, localStorageSave } from '../../../../services/localStorageService';
import { createFiltersConfig, FiltersManager } from "../../../../components/FiltersManager/FiltersManager";
import { SortingButton } from "../../../../components/Sorting/SortingButton";
import { SortingProvider } from "../../../../contexts/SortingContext";
import { SortingHeader } from "../../../../components/Sorting/SortingHeader";


const orderManagementDraftPrefix = "supplyChain/orderManagement/draft/"

export const OrdersManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dataBreadCrumbs = [
    <Link
      key={1}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/customdashboard");
      }}
    >
      Modules
    </Link>,
    <Link
      key={2}
      underline="hover"
      sx={{ color: "#000000", cursor: "pointer", fontSize: "var(--p-size)" }}
      onClick={() => {
        dispatch(clearActiveTab());
        navigate("/secure/supplychain");
      }}
    >
      Supply Chain
    </Link>,
    <Link
      key={3}
      underline="none"
      sx={{ color: "#000000", cursor: "default", fontSize: "var(--p-size)" }}
    >
      Order Management
    </Link>,
  ];
  const [viewFilters, setViewFilters] = useState(false);

  const location = useLocation();
  const [companyDrop, setCompanyDrop] = useState(null);
  const [companyDropData, setCompanyDropData] = useState([]);
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");
  const { dataFromPrns, companySource } = location.state || {};
  const [orderStatusDrop, setOrderStatusDrop] = useState(null);
  const [orderTypeDrop, setOrderTypeDrop] = useState(null);
  const [orderNumber, setOrderNumberDrop] = useState(null);
  const [priorityDrop, setPriorityDrop] = useState(null);
  const [PRNDrop, setPRNDrop] = useState(null);
  const [PNDrop, setPNDrop] = useState(null);
  const [SNDrop, setSNDrop] = useState(null);
  const [categoryDrop, setCategoryDrop] = useState(null);
  const [locationDrop, setLocationDrop] = useState(null);
  const [sitesDrop, setSitesDrop] = useState(null);
  const [vendorsDrop, setVendorsDrop] = useState(null);
  const [chapterDrop, setChapterDrop] = useState(null);
  const [sectionDrop, setSectionDrop] = useState(null);
  const [ACDrop, setACDrop] = useState(null);
  const [WPDrop, setWPDrop] = useState(null);
  const [TCDrop, setTCDrop] = useState(null);
  const [FNDDrop, setFNDDrop] = useState(null);
  const [AWBDrop, setAWBDrop] = useState(null);
  const [supplyChainUserDrop, setSupplyChainUserDrop] = useState(null);
  const [resetDateRange, setResetDateRange] = useState(0);

  const [ordersList, setOrdersList] = useState([]);
  const [draftOrders, setDraftOrders] = useState([])
  const [allOrders, setAllOrders] = useState([])
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(environment.ElemensPerPage);
  const [maxPages, setMaxPages] = useState(0);

  const [sortingOrder, setSortingOrder] = useState("order_type");
  const [tcParameters , setTcparameters] = useState(null);
  // dropdowns selection
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedPRN, setSelectedPRN] = useState([]);
  const [selectedPN, setSelectedPN] = useState([]);
  const [selectedSN, setSelectedSN] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [selectedChapter, setSelectedChapter] = useState([]);
  const [selectedSection, setSelectedSection] = useState([]);
  const [selectedAC, setSelectedAC] = useState([]);
  const [selectedWP, setSelectedWP] = useState([]);
  const [selectedTC, setSelectedTC] = useState([]);
  const [selectedFND, setSelectedFND] = useState([]);
  const [selectedOrderType, setSelectedOrderType] = useState([]);
  const [selectedPriority, setSelectedPriority] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [selectedAWB, setSelectedAWB] = useState([]);
  const [selectedSupplyChainUser, setSelectedSupplyChainUser] = useState([]);
  const [selectedOrderStatus, setSelectedOrderStatus] = useState([]);
  const [createdDateRange, setCreatedDateRange] = useState(null);
  const [deliveryDateRange, setDeliveryDateRange] = useState(null);
  const [receivedDateRange, setReceivedDateRange] = useState(null);
  const [resetCreatedDateRange, setResetCreatedDateRange] = useState(0);
  const [resetDeliveryDateRange, setResetDeliveryDateRange] = useState(0);
  const [resetReceivedDateRange, setResetReceivedDateRange] = useState(0);

  // states to handle single selection

  const [companyOptionToDelete, setCompanyOptionToDelete] = useState(null);
  const [PRNOptionToDelete, setPRNOptionToDelete] = useState(null);
  const [PNOptionToDelete, setPNOptionToDelete] = useState(null);
  const [SNOptionToDelete, setSNOptionToDelete] = useState(null);
  const [categoryOptionToDelete, setCategoryOptionToDelete] = useState(null);
  const [locationOptionToDelete, setLocationOptionToDelete] = useState(null);
  const [sitesOptionToDelete, setSitesOptionToDelete] = useState(null);
  const [vendorsOptionToDelete, setVendorsOptionToDelete] = useState(null);
  const [chapterOptionToDelete, setChapterOptionToDelete] = useState(null);
  const [sectionOptionToDelete, setSectionOptionToDelete] = useState(null);
  const [ACOptionToDelete, setACOptionToDelete] = useState(null);
  const [WPOptionToDelete, setWPOptionToDelete] = useState(null);
  const [TCOptionToDelete, setTCOptionToDelete] = useState(null);
  const [FNDOptionToDelete, setFNDOptionToDelete] = useState(null);
  const [orderTypeOptionToDelete, setOrderTypeOptionToDelete] = useState(null);
  const [priorityOptionToDelete, setPriorityOptionToDelete] = useState(null);
  const [orderOptionToDelete, setOrderOptionToDelete] = useState(null);
  const [AWBOptionToDelete, setAWBOptionToDelete] = useState(null);
  const [supplyChainUserOptionToDelete, setSupplyChainUserOptionToDelete] =
    useState(null);
  const [orderStatusOptionToDelete, setOrderStatusOptionToDelete] =
    useState(null);

  const [preselectCompany, setPreselectCompany] = useState();
  const [preselectPRN, setPreselectPRN] = useState();
  const [preselectPN, setPreselectPN] = useState();
  const [preselectSN, setPreselectSN] = useState();
  const [preselectCategory, setPreselectCategory] = useState();
  const [preselectLocation, setPreselectLocation] = useState();
  const [preselectSites, setPreselectSites] = useState();
  const [preselectVendors, setPreselectVendors] = useState();
  const [preselectChapter, setPreselectChapter] = useState();
  const [preselectSection, setPreselectSection] = useState();
  const [preselectAC, setPreselectAC] = useState();
  const [preselectWP, setPreselectWP] = useState();
  const [preselectTC, setPreselectTC] = useState();
  const [preselectFND, setPreselectFND] = useState();
  const [preselectPriority, setPreselectPriority] = useState();
  const [preselectOrder, setPreselectOrder] = useState();
  const [preselectAWB, setPreselectAWB] = useState();
  const [preselectSupplyChainUser, setPreselectSupplyChainUser] = useState();
  const [preselectOrderStatus, setPreselectOrderStatus] = useState();
  const [preselectOrderType, setPreselectOrderType] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [priceRange, setPriceRange] = useState(null);
  // const {setUserApprovalRange} = useContext(OrderManagementContext);
  const debounceRef = useRef(null);
  const orderListRef = useRef(null);


  const getCompanyFilter = () => {
    const companies = JSON.parse(localStorage.getItem("u_companies")) || [];
    return {
      columnName: "company_id",
      value: companies.map((e) => e.id),
    };
  };

  const [body, setBody] = useState(getCompanyFilter());


  const handleScroll = () => {
    const list = orderListRef.current;
    if (list) {
      const { scrollTop, scrollHeight, clientHeight } = list;
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        getMorePartRequest();
      }
    }
  };

  const getMorePartRequest = () => {
    if (loading || page >= maxPages) {
      return;
    }
    getOrders(page, pageSize, "", sortingOrder, body, true);
  };

  const handleOpenFiltersMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setPopoverOpen(true);
  };


  const handlePopoverMouseEnter = () => {
    setPopoverOpen(true);
  };



  const open = Boolean(anchorEl);

  const formatEndOfDay = (dateString) => {
    if (!dateString) return null;

    const date = new Date(dateString);
    date.setHours(23, 59, 59, 999);
    return date.toISOString();
  };

  const processDateRange = (dateRange) => {
    if (!dateRange?.startDate && !dateRange?.endDate) return undefined;

    return {
      startDate: dateRange.startDate,
      endDate: formatEndOfDay(dateRange.endDate),
    };
  };
  useEffect(() => {
    if (viewFilters) {
      const hasFiltersChanged =
        selectedOrderType.length > 0 ||
        selectedCompany.length > 0 ||
        selectedPRN.length > 0 ||
        selectedPN.length > 0 ||
        selectedSN.length > 0 ||
        selectedCategory.length > 0 ||
        selectedLocation.length > 0 ||
        selectedSites.length > 0 ||
        selectedVendors.length > 0 ||
        selectedChapter.length > 0 ||
        selectedSection.length > 0 ||
        selectedAC.length > 0 ||
        selectedWP.length > 0 ||
        selectedTC.length > 0 ||
        selectedFND.length > 0 ||
        selectedPriority.length > 0 ||
        selectedOrder.length > 0 ||
        selectedAWB.length > 0 ||
        selectedSupplyChainUser.length > 0 ||
        createdDateRange ||
        deliveryDateRange ||
        receivedDateRange ||
        selectedOrderStatus.length > 0;
      status != null || (dataFromPrns && dataFromPrns.length > 0);

      if (hasFiltersChanged) {
        const newBody = [
          getCompanyFilter(),
          selectedOrderType.length > 0 && {
            columnName: "order_type",
            value: selectedOrderType.map((e) => e.id),
          },
          selectedPRN.length > 0 && {
            columnName: "part_request_number",
            value: selectedPRN.map((e) => e.id),
            isListString: true,
          },
          selectedPN.length > 0 && {
            columnName: "part_numbers",
            value: selectedPN.map((e) => e.id),
            isListString: true,
          },
          selectedSN.length > 0 && {
            columnName: "serial_number",
            value: selectedSN.map((e) => e.id),
          },
          selectedCategory.length > 0 && {
            columnName: "category",
            value: selectedCategory.map((e) => e.id),
          },
          selectedLocation.length > 0 && {
            columnName: "location_id",
            value: selectedLocation.map((e) => e.id),
          },
          createdDateRange?.startDate || createdDateRange?.endDate
            ? {
              columnName: "created_date",
              value: processDateRange(createdDateRange),
            }
            : undefined,

          deliveryDateRange?.startDate || deliveryDateRange?.endDate
            ? {
              columnName: "estDeliveryDate",
              value: processDateRange(deliveryDateRange),
            }
            : undefined,

          receivedDateRange?.startDate || receivedDateRange?.endDate
            ? {
              columnName: "received_date",
              value: processDateRange(receivedDateRange),
            }
            : undefined,
          selectedSites.length > 0 && {
            columnName: "site_id",
            value: selectedSites.map((e) => e.id),
          },
          selectedVendors.length > 0 && {
            columnName: "vendor_name",
            value: selectedVendors.map((e) => e.name),
          },
          selectedPriority.length > 0 && {
            columnName: "priority",
            value: selectedPriority.map((e) => e.name),
          },
          selectedChapter.length > 0 && {
            columnName: "ata_chapter_ids",
            value: selectedChapter.map((e) => e.id),
            isListString: true,

          },
          selectedSection.length > 0 && {
            columnName: "ata_section_ids",
            value: selectedSection.map((e) => e.id),
            isListString: true,

          },
          selectedAC.length > 0 && {
            columnName: "tail_number",
            value: selectedAC.map((e) => e.id),
          },
          selectedWP.length > 0 && {
            columnName: "wp",
            value: selectedWP.map((e) => e.id),
            isListString: true,
          },
          selectedTC.length > 0 && {
            columnName: "tc_fnd",
            value: selectedTC.map((e) => e.id),
          },
          selectedFND.length > 0 && {
            columnName: "tc_fnd",
            value: selectedFND.map((e) => e.id),
          },
          selectedOrder.length > 0 && {
            columnName: "order_number",
            value: selectedOrder.map((e) => e.id),
          },
          selectedAWB.length > 0 && {
            columnName: "awb",
            value: selectedAWB.map((e) => e.id),
          },
          selectedSupplyChainUser.length > 0 && {
            columnName: "supply_chain",
            value: selectedSupplyChainUser.map((e) => e.id),
          },
          dataFromPrns &&
          dataFromPrns.length > 0 && {
            columnName: "id",
            value: dataFromPrns,
          },
          companySource != null && {
            columnName: "company_Id",
            value: [companySource],
          },
          status != null && {
            columnName: "status",
            value: [status],
          },

          selectedOrderStatus?.length > 0 && {
            columnName: "status",
            value: selectedOrderStatus.map((e) => e.status),
          },
        ].filter(Boolean);
        setBody(newBody);

        getOrders(0, pageSize, "", sortingOrder, newBody);
      }
    }
  }, [
    selectedCompany,
    selectedPRN,
    selectedPN,
    selectedSN,
    selectedCategory,
    selectedLocation,
    selectedSites,
    selectedVendors,
    selectedChapter,
    selectedSection,
    selectedAC,
    selectedWP,
    selectedTC,
    selectedFND,
    selectedOrderType,
    selectedPriority,
    selectedOrder,
    selectedAWB,
    selectedSupplyChainUser,
    createdDateRange,
    deliveryDateRange,
    receivedDateRange,
    selectedOrderStatus,
    dataFromPrns,
    status,
  ]);

  const getUserPriceRanges = async () => {
    let request = await getApprovalPriceRanges()

    if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
      setPriceRange(request.data.load);
    }
  }

  const getSortingChange = (data) => {
    setSortingOrder(data);
  };

  const getOrders = async (
    p = page,
    Ps = pageSize,
    search = "",
    order = sortingOrder,
    body = [],
    isScroll = false
  ) => {
    setLoading(true);
    try {
      let draftOrdersList = localStorageGet(orderManagementDraftPrefix, {})
      let request = await getOrdersList(p, Ps, search, order, body);
      setMaxPages(request.data.totalPages);
      if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
        if (isScroll) {
          setOrdersList((prev) => [...prev, ...request.data.load]);
          setPage((prevPage) => {
            return prevPage + 1;
          });
        } else {
          setDraftOrders(draftOrdersList)
          setOrdersList(()=>{
            return [...request.data.load]
          });
          setPage(1);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const combineOrders = () => {

    const ordersInDraft =
      draftOrders?.length > 0 ? draftOrders : [];

    const uniqueDraftOrders = ordersInDraft.filter(
      (element) =>
        !ordersList.some(
          (e) => e.id === element.id
        )
    );

    setAllOrders([...uniqueDraftOrders, ...ordersList]);
  };

  useEffect(() => {
    combineOrders()
  }, [ordersList, draftOrders])

  const getDropdownConfigOrderType = async () => {
    let id = 112;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setOrderTypeDrop(request.data.load);
    }
  };

  const getDropdownConfigCompany = async () => {
    let id = 91;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCompanyDrop(request.data.load);
    }
  };

  const getDropdownConfigPRN = async () => {
    let id = 104;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPRNDrop(request.data.load);
    }
  };

  const getDropdownConfigPN = async () => {
    let id = 1;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPNDrop(request.data.load);
    }
  };

  const getDropdownConfigSN = async () => {
    let id = 100;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSNDrop(request.data.load);
    }
  };

  const getDropdownConfigCategory = async () => {
    let id = 2;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setCategoryDrop(request.data.load);
    }
  };

  const getDropdownConfigLocation = async () => {
    let id = 87;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setLocationDrop(request.data.load);
    }
  };

  const getDropdownConfigSites = async () => {
    let id = 102;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSitesDrop(request.data.load);
    }
  };

  const getDropdownConfigVendors = async () => {
    let id = 127;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setVendorsDrop(request.data.load);
    }
  };

  const getDropdownConfigChapter = async () => {
    let id = 11;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setChapterDrop(request.data.load);
    }
  };

  const getDropdownConfigSection = async () => {
    let id = 12;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSectionDrop(request.data.load);
    }
  };

  const getDropdownConfigAC = async () => {
    let id = 88;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setACDrop(request.data.load);
    }
  };

  const getDropdownConfigWP = async () => {
    let id = 93;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setWPDrop(request.data.load);
    }
  };

  const getDropdownConfigTC = async () => {
    let id = 90;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setTCDrop(request.data.load);
    }
  };

  const getDropdownConfigFND = async () => {
    let id = 89;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setFNDDrop(request.data.load);
    }
  };
  const getDropdownConfigPriority = async () => {
    let id = 113;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPriorityDrop(request.data.load);
    }
  };
  const getDropdownConfigOrderNumber = async () => {
    let id = 116;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setOrderNumberDrop(request.data.load);
    }
  };

  const getDropdownConfigAWB = async () => {
    let id = 117;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setAWBDrop(request.data.load);
    }
  };

  const getDropdownConfigSupplyChainUser = async () => {
    let id = 119;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setSupplyChainUserDrop(request.data.load);
    }
  };

  const getDropdownConfigOrdersStatus = async () => {
    let id = 120;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setOrderStatusDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigOrderType(),
      getDropdownConfigCompany(),
      getDropdownConfigPRN(),
      getDropdownConfigPN(),
      getDropdownConfigSN(),
      getDropdownConfigCategory(),
      getDropdownConfigLocation(),
      getDropdownConfigSites(),
      getDropdownConfigVendors(),
      getDropdownConfigChapter(),
      getDropdownConfigSection(),
      getDropdownConfigAC(),
      getDropdownConfigWP(),
      getDropdownConfigTC(),
      getDropdownConfigFND(),
      getDropdownConfigPriority(),
      getDropdownConfigOrderNumber(),
      getDropdownConfigAWB(),
      getDropdownConfigSupplyChainUser(),
      getDropdownConfigOrdersStatus(),
    ]);

    return results;
  };

  const clearFilters = () => {
    setSearchValue("");

    const arraySetters = [
      setSelectedCompany,
      setSelectedPRN,
      setSelectedPN,
      setSelectedSN,
      setSelectedCategory,
      setSelectedLocation,
      setSelectedSites,
      setSelectedVendors,
      setSelectedChapter,
      setSelectedSection,
      setSelectedAC,
      setSelectedWP,
      setSelectedTC,
      setSelectedFND,
      setSelectedOrderType,
      setSelectedPriority,
      setSelectedOrderStatus,
    ];

    arraySetters.forEach((setter) => setter([]));

    setCreatedDateRange(null);
    setDeliveryDateRange(null);
    setReceivedDateRange(null);

    const preselectSetters = [//preselects
      setPreselectCompany,
      setPreselectPRN,
      setPreselectPN,
      setPreselectSN,
      setPreselectCategory,
      setPreselectLocation,
      setPreselectSites,
      setPreselectVendors,
      setPreselectChapter,
      setPreselectSection,
      setPreselectAC,
      setPreselectWP,
      setPreselectTC,
      setPreselectFND,
      setPreselectPriority,
      setPreselectOrderStatus,
      setPreselectOrder,
      setPreselectAWB,
      setPreselectSupplyChainUser,
      setPreselectOrderType,
    ];

    preselectSetters.forEach((setter) => setter(null));

    setBody(() => {
      const updatedData = [
        getCompanyFilter(),
      ];
      getOrders(0, pageSize, "", sortingOrder, updatedData);
      return updatedData;
    });
  };


  const mountSearch = useRef(false);
  const handleSearch = (e) => {
    if (!mountSearch.current) {
      mountSearch.current = true;
      return;
    }
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      getOrders(0, pageSize, e, sortingOrder, body, false);
    }, environment.debounceTime);
  };

  useEffect(() => {
    if (body.length == 1 || body.length == 0) {
      setAnchorEl(null);
    }
  }, [body]);
  useEffect(()=> {
    setTcparameters(()=>{
      return [{
        columnName : "wpId",
        value : selectedTC.id
      }]
    })
  } , [selectedTC])

  useEffect(() => {
    handleSearch(searchValue);
  }, [searchValue]);

  useEffect(() => {
    if (viewFilters) {
      getAllDropdowns();
    }
  }, [viewFilters]);

  useEffect(() => {
    let newBody = [
      getCompanyFilter(),

    ];
    if (dataFromPrns && dataFromPrns.length > 0) {
      newBody.push(
        {
          columnName: "id",
          value: dataFromPrns,
        },
        {
          columnName: "company_Id",
          value: [companySource],
        }
      );
    }
    if (status != null) {
      newBody.push({
        columnName: "status",
        value: [status],
      });
    }
    setBody(newBody);
    getOrders(0, pageSize, "", sortingOrder, newBody);
    getUserPriceRanges()

    // setCompanyDropData(() => JSON.parse(localStorage.getItem("u_companies")))
  }, []);

  const didMount = useRef(false);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    getOrders(0, pageSize, "", sortingOrder, body);
  }, [sortingOrder]);

  useEffect(() => {
    const list = orderListRef.current;
    if (list) {
      list.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (list) {
        list.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  function generateUUID() {
    return crypto.randomUUID();
  }

  const goBackDataObj = {
    icon: "icon-store_module_icon",
    color: "#EB9090",
    path: "/store",
    title: "Store",
    isPinned: false,
    componentKey: "Stores",
    id: -1,
    isModule: true,
    date: generateUUID(),
  };



  const findOptionToRemove = (columnName, val) => {
    switch (columnName) {
      case "order_type":
        return selectedOrderType.find((opt) => opt.id === val);
      case "part_request_number":
        return selectedPRN.find((opt) => opt.id === val);
      case "part_number_list":
        return selectedPN.find((opt) => opt.id === val);
      default:
        return { id: val };
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };


  const [dropdownsCompanyParameters, setDropdownsCompanyParameters] = useState([
    { columnName: "companyId", value: localStorage.getItem("u_company_id") },
  ]);

  // const getDisplayValue = (columnName, value) => {
  //   // Buscamos la opción completa en el estado correspondiente
  //   let option;

  //   switch (columnName) {
  //     case "order_type":
  //       option = selectedOrderType.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "part_request_number":
  //       option = selectedPRN.find((item) => item.id === value);
  //       return option?.code || value;

  //     case "part_number_list":
  //       option = selectedPN.find((item) => item.id === value);
  //       return option?.part_number || value;

  //     case "serial_number":
  //       option = selectedSN.find((item) => item.id === value);
  //       return option?.serial_number || value;

  //     case "category":
  //       option = selectedCategory.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "location_id":
  //       option = selectedLocation.find((item) => item.id === value);
  //       return option?.code || value;

  //     case "site_id":
  //       option = selectedSites.find((item) => item.id === value);
  //       return option?.site_code || value;

  //     case "vendor_name":
  //       option = selectedVendors.find((item) => item.name === value);
  //       return option?.name || value;

  //     case "priority":
  //       return value;

  //     case "ata_chapter_ids":
  //       option = selectedChapter.find((item) => item.id === value);
  //       return option?.chapter_number || value;

  //     case "ata_section_ids":
  //       option = selectedSection.find((item) => item.id === value);
  //       return option?.section_number || value;

  //     case "tail_number":
  //       option = selectedAC.find((item) => item.id === value);
  //       return option?.tail_number || value;

  //     case "wp":
  //       option = selectedWP.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "tc":
  //       option = selectedTC.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "fnd":
  //       option = selectedFND.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "order_number":
  //       option = selectedOrder.find((item) => item.id === value);
  //       return option?.order_number || value;

  //     case "awb":
  //       option = selectedAWB.find((item) => item.id === value);
  //       return option?.awb_number || value;

  //     case "supply_chain":
  //       option = selectedSupplyChainUser.find((item) => item.id === value);
  //       return option?.name || value;

  //     case "status":
  //       return value;

  //     default:
  //       return value;
  //   }
  // };
  // const clearFilterOptionsGroup = (columnName) => {
  //   switch (columnName) {
  //     case "order_type":
  //       setPreselectOrderType(null);

  //       break;
  //     case "part_request_number":
  //       setPreselectPRN(null);
  //       break;
  //     case "part_number_list":
  //       setPreselectPN(null);

  //       break;
  //     case "serial_number":
  //       setPreselectSN(null);
  //       break;
  //     case "category":
  //       break;
  //     case "location_id":
  //       setPreselectLocation(null);
  //       break;
  //     case "created_date":
  //       setResetCreatedDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "estDeliveryDate":
  //       setResetDeliveryDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "received_date":
  //       setResetReceivedDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "site_id":
  //       setPreselectSites(null);

  //       break;
  //     case "vendor_name":
  //       setPreselectVendors(null);

  //       break;
  //     case "priority":
  //       setPreselectPriority(null);

  //       break;
  //     case "ata_chapter_ids":
  //       setPreselectChapter(null);
  //       break;
  //     case "ata_section_ids":
  //       setPreselectSection(null);

  //       break;
  //     case "tail_number":
  //       setPreselectAC(null);

  //       break;
  //     case "wp":
  //       setPreselectWP(null);

  //       break;
  //     case "tc":
  //       setPreselectTC(null);

  //       break;
  //     case "fnd":
  //       setPreselectFND(null);

  //       break;
  //     case "order_number":
  //       setPreselectOrder(null);

  //       break;
  //     case "awb":
  //       setPreselectAWB(null);
  //       break;
  //     case "supply_chain":
  //       setPreselectSupplyChainUser(null);
  //       break;
  //     case "status":
  //       setPreselectOrderStatus(null);

  //       break;
  //     default:
  //       break;
  //   }
  // };

  //   const getFilterLabel = (columnName) => {
  //   const labels = {
  //     order_type: "Order Type",
  //     part_request_number: "Part Request",
  //     part_number_list: "Part Number",
  //     serial_number: "Serial Number",
  //     category: "Category",
  //     location_id: "Location",
  //     created_date: "Created Date",
  //     estDeliveryDate: "Delivery Date",
  //     received_date: "Received Date",
  //     site_id: "Site",
  //     vendor_name: "Vendor",
  //     priority: "Priority",
  //     ata_chapter_ids: "Chapter",
  //     ata_section_ids: "Section",
  //     tail_number: "Tail Number",
  //     wp: "WP",
  //     tc: "TC",
  //     fnd: "FND",
  //     order_number: "Order Number",
  //     awb: "AWB",
  //     supply_chain: "Supply Chain",
  //     status: "Status",
  //   };
  //   return labels[columnName] || columnName;
  // };

  //   const deleteSingleFilter = (columnName, valueToRemove) => {
  //   switch (columnName) {
  //     case "order_type":
  //       setSelectedOrderType((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setOrderTypeOptionToDelete(valueToRemove);
  //       break;
  //     case "part_request_number":
  //       setSelectedPRN((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setPRNOptionToDelete(valueToRemove);
  //       break;
  //     case "part_number_list":
  //       setSelectedPN((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setPNOptionToDelete(valueToRemove);

  //       break;
  //     case "serial_number":
  //       setSelectedSN((prev) =>
  //         prev.filter((item) => item.tail_number !== valueToRemove)
  //       );
  //       setSNOptionToDelete(valueToRemove);
  //       break;
  //     case "category":
  //       setSelectedCategory((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setCategoryOptionToDelete(valueToRemove);

  //       break;
  //     case "location_id":
  //       setSelectedLocation((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setLocationOptionToDelete(valueToRemove);

  //       break;
  //     case "created_date":
  //       setResetCreatedDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "estDeliveryDate":
  //       setResetDeliveryDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "received_date":
  //       setResetReceivedDateRange((prev) => {
  //         return prev + 1;
  //       });
  //       break;
  //     case "site_id":
  //       setSelectedSites((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setSitesOptionToDelete(valueToRemove);

  //       break;
  //     case "vendor_name":
  //       setSelectedVendors((prev) =>
  //         prev.filter((item) => item.name !== valueToRemove)
  //       );
  //       setVendorsOptionToDelete(valueToRemove);

  //       break;
  //     case "priority":
  //       setSelectedPriority((prev) =>
  //         prev.filter((item) => item.name !== valueToRemove)
  //       );
  //       setPriorityOptionToDelete(valueToRemove);

  //       break;
  //     case "ata_chapter_ids":
  //       setSelectedChapter((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setChapterOptionToDelete(valueToRemove);

  //       break;
  //     case "ata_section_ids":
  //       setSelectedSection((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setSectionOptionToDelete(valueToRemove);

  //       break;
  //     case "tail_number":
  //       setSelectedAC((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setACOptionToDelete(valueToRemove);

  //       break;
  //     case "wp":
  //       setSelectedWP((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setWPOptionToDelete(valueToRemove);

  //       break;
  //     case "tc":
  //       setSelectedTC((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setTCOptionToDelete(valueToRemove);

  //       break;
  //     case "fnd":
  //       setSelectedFND((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setFNDOptionToDelete(valueToRemove);

  //       break;
  //     case "order_number":
  //       setSelectedOrder((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setOrderOptionToDelete(valueToRemove);

  //       break;
  //     case "awb":
  //       setSelectedAWB((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setAWBOptionToDelete(valueToRemove);
  //       break;
  //     case "supply_chain":
  //       setSelectedSupplyChainUser((prev) =>
  //         prev.filter((item) => item.id !== valueToRemove)
  //       );
  //       setSupplyChainUserOptionToDelete(valueToRemove);

  //       break;
  //     case "status":
  //       setSelectedOrderStatus((prev) =>
  //         prev.filter((item) => item.status !== valueToRemove)
  //       );
  //       setOrderStatusOptionToDelete(valueToRemove);

  //       break;
  //     default:
  //       break;
  //   }

  //   setBody((prevBody) => {
  //     const updatedBody = prevBody
  //       .map((item) => {
  //         if (item.columnName === columnName) {
  //           if (columnName.includes("_date")) {
  //             return null;
  //           }

  //           const updatedValues = item.value.filter(
  //             (val) => val !== valueToRemove
  //           );
  //           return updatedValues.length > 0
  //             ? { ...item, value: updatedValues }
  //             : null;
  //         }
  //         return item;
  //       })
  //       .filter(Boolean);
  //     getOrders(0, pageSize, "", sortingOrder, updatedBody);
  //     return updatedBody;
  //   });
  // };

  const rawFilters = {
    order_type: {
      selected: selectedOrderType,
      setSelected: setSelectedOrderType,
      setPreselect: setPreselectOrderType,
      setToDelete: setOrderTypeOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    part_request_number: {
      selected: selectedPRN,
      setSelected: setSelectedPRN,
      setPreselect: setPreselectPRN,
      setToDelete: setPRNOptionToDelete,
      getDisplay: (item) => item?.code,
    },
    part_number_list: {
      selected: selectedPN,
      setSelected: setSelectedPN,
      setPreselect: setPreselectPN,
      setToDelete: setPNOptionToDelete,
      getDisplay: (item) => item?.part_number,
    },
    serial_number: {
      selected: selectedSN,
      setSelected: setSelectedSN,
      setPreselect: setPreselectSN,
      setToDelete: setSNOptionToDelete,
      getDisplay: (item) => item?.serial_number,
    },
    category: {
      selected: selectedCategory,
      setSelected: setSelectedCategory,
      setPreselect: () => { },
      setToDelete: setCategoryOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    location_id: {
      selected: selectedLocation,
      setSelected: setSelectedLocation,
      setPreselect: setPreselectLocation,
      setToDelete: setLocationOptionToDelete,
      getDisplay: (item) => item?.code,
    },
    site_id: {
      selected: selectedSites,
      setSelected: setSelectedSites,
      setPreselect: setPreselectSites,
      setToDelete: setSitesOptionToDelete,
      getDisplay: (item) => item?.site_code,
    },
    vendor_name: {
      selected: selectedVendors,
      setSelected: setSelectedVendors,
      setPreselect: setPreselectVendors,
      setToDelete: setVendorsOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    priority: {
      selected: selectedPriority,
      setSelected: setSelectedPriority,
      setPreselect: setPreselectPriority,
      setToDelete: setPriorityOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    ata_chapter_ids: {
      selected: selectedChapter,
      setSelected: setSelectedChapter,
      setPreselect: setPreselectChapter,
      setToDelete: setChapterOptionToDelete,
      getDisplay: (item) => item?.chapter_number,
    },
    ata_section_ids: {
      selected: selectedSection,
      setSelected: setSelectedSection,
      setPreselect: setPreselectSection,
      setToDelete: setSectionOptionToDelete,
      getDisplay: (item) => item?.section_number,
    },
    tail_number: {
      selected: selectedAC,
      setSelected: setSelectedAC,
      setPreselect: setPreselectAC,
      setToDelete: setACOptionToDelete,
      getDisplay: (item) => item?.tail_number,
    },
    wp: {
      selected: selectedWP,
      setSelected: setSelectedWP,
      setPreselect: setPreselectWP,
      setToDelete: setWPOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    tc: {
      selected: selectedTC,
      setSelected: setSelectedTC,
      setPreselect: setPreselectTC,
      setToDelete: setTCOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    fnd: {
      selected: selectedFND,
      setSelected: setSelectedFND,
      setPreselect: setPreselectFND,
      setToDelete: setFNDOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    order_number: {
      selected: selectedOrder,
      setSelected: setSelectedOrder,
      setPreselect: setPreselectOrder,
      setToDelete: setOrderOptionToDelete,
      getDisplay: (item) => item?.order_number,
    },
    awb: {
      selected: selectedAWB,
      setSelected: setSelectedAWB,
      setPreselect: setPreselectAWB,
      setToDelete: setAWBOptionToDelete,
      getDisplay: (item) => item?.awb_number,
    },
    supply_chain: {
      selected: selectedSupplyChainUser,
      setSelected: setSelectedSupplyChainUser,
      setPreselect: setPreselectSupplyChainUser,
      setToDelete: setSupplyChainUserOptionToDelete,
      getDisplay: (item) => item?.name,
    },
    status: {
      selected: selectedOrderStatus,
      setSelected: setSelectedOrderStatus,
      setPreselect: setPreselectOrderStatus,
      setToDelete: setOrderStatusOptionToDelete,
      getDisplay: (item) => item?.status,
    },
  };


  const filtersConfig = createFiltersConfig(rawFilters, setBody, getOrders, [0, pageSize, "", sortingOrder])

  const reloadOrders = (id) => {
    if (id) {
      setDraftOrders(po => po.filter(s => s.id !== id));
    }
    setOrdersList([])
    getOrders(0, pageSize, searchValue, sortingOrder, body, false)
  }


  const handleSortingFiltersChange = (fullSelectedMap) => {
    setBody((prevBody) => {
      const updatedBody = [...prevBody];

      Object.entries(fullSelectedMap).forEach(([columnName, fullSelected]) => {
        const index = updatedBody.findIndex((f) => f.columnName === columnName);

        if (!fullSelected || fullSelected.length === 0) {
          if (index !== -1) {
            updatedBody.splice(index, 1);
          }

          if (columnName === "order_type") {
            setSelectedOrderType([]);
          } else if (columnName === "status") {
            setSelectedOrderStatus([]);
          } else if (columnName === "order_number") {
            setSelectedOrder([]);
          } else if (columnName === "location_id") {
            setSelectedLocation([]);
          } else if (columnName === "site_id") {
            setSelectedSites([]);
          } else if (columnName === "priority") {
            setSelectedPriority([]);
          } else if (columnName === "vendor") {
            setSelectedVendors([]);
          } else if (columnName === "supply_user") {
            setSelectedSupplyChainUser([]);
          }

          return;
        }

        if (index !== -1) {
          updatedBody[index].value = fullSelected.map((item) => item.id ?? item); // según lo que uses
        } else {
          updatedBody.push({
            columnName,
            value: fullSelected.map((item) => item.id || item.status || item), // ajusta según tu extractor
          });
        }

        if (columnName === "order_type") {
          setSelectedOrderType(fullSelected);
        } else if (columnName === "status") {
          setSelectedOrderStatus(fullSelected);
        } else if (columnName === "order_number") {
          setSelectedOrder(fullSelected);
        } else if (columnName === "location_id") {
          setSelectedLocation(fullSelected);
        } else if (columnName === "site_id") {
          setSelectedSites(fullSelected);
        } else if (columnName === "priority") {
          setSelectedPriority(fullSelected);
        } else if (columnName === "vendor") {
          setSelectedVendors(fullSelected);
        } else if (columnName === "supply_user") {
          setSelectedSupplyChainUser(fullSelected);
        }
      });

      getOrders(0, pageSize, "", sortingOrder, updatedBody);
      return updatedBody;
    });
  }

  return (
    <SortingProvider
      onOrderChange={getSortingChange}
      properties={{
        order_type: "Order Type",
        status: "Status",
        order_number: "Order N°",
        location_id: "Location",
        site_id: "Site",
        estDeliveryDate: "Date Required",
        priority: "Priority",
        vendor: "Vendor",
        supply_user: "Order Owner Id",
        name: "Company",
        created: "Created",
        days_since: "Days Since",
        total_cost: "Total Cost",
      }}
      columnFilterProperties={{
        order_type: 112,
        status: 120,
        order_number: 116,
        location_id: 87,
        site_id: 102,
        priority: 113,
        vendor: 127,
        // supply_user: 119,
      }}
    >
      <section className="order-management">
        <section section className="order-management-nav">
          <NavBar
            dataBreadCrumbs={"/supplychain/orders-management"}
            appIcon={"icon-part_request_icon"}
            // moduleIcon={"icon-settings"}
            moduleColor="#0077FF"
            title={"Order Management"}
            menuTitle={"Supply Chain"}
            moduleId={12}
            currentPath={"store/orders-management"}
            previousPath={"/store"}
            goBackData={goBackDataObj}
            isLocalSearch
            searchInputProps={{
              type: "text",
              onTextChange: (e) => {
                setSearchValue(e);
              },
            }}

            searchActions={
              <>
                <FiltersManager
                  appliedFilters={body}
                  onFilterChange={setBody}
                  handleClearAllFilters={clearFilters}
                  onClearGroup={(col) => filtersConfig[col]?.clearGroup?.()}
                  onDeleteFilter={(col, val) => filtersConfig[col]?.deleteValue?.(val)}
                  getFilterLabel={(col) => filtersConfig[col]?.label || col}
                  getDisplayValue={(col, val) => filtersConfig[col]?.getDisplayValue(val) || val}
                  onButtonClick={() => { setViewFilters(!viewFilters) }}
                  excludeColumns={["company_id"]}
                />

                <SortingButton></SortingButton>
              </>
            }
          >
            {/* {body.length > 1 && !viewFilters ? (
              <Tooltip title="Clear Active Filters" arrow>
                <p
                  className="orders-clearAll-filters-header"
                  onClick={clearFilters}
                >
                  Clear All
                </p>
              </Tooltip>
            ) : (
              ""
            )} */}

            {/* <button
            className="orders-management-filters-btn"
            onClick={() => {
              setViewFilters(!viewFilters);
            }}
          >
            Filters
            {body.length > 1 && !viewFilters ? (
              <span
                className="orders-active-filters"
                onMouseEnter={(e) => {
                  e.stopPropagation()
                  handleOpenFiltersMenu(e)
                }}
              >
                {countAppliedFilters()}
              </span>
            ) : (
              ""
            )}
            <i
              style={{
                transition: "var(--transition)",
                transform: viewFilters ? "rotate(180deg)" : "",
              }}
              className="icon-arrow-down"
            ></i>
          </button> */}

          </NavBar>
          <section
            className="orders-management-filters-cont"
            style={{
              opacity: viewFilters ? 1 : 0,
              visibility: viewFilters ? "visible" : "hidden",
              // height: viewFilters ? "45vh" : 0,
              // minHeight: viewFilters ? "15rem" : 0,
              maxHeight: viewFilters ? "10rem" : 0,
              padding : viewFilters ? "0 0 .5rem .1rem" : "0"
            }}
          >
            <div>
              {orderStatusDrop ? (
                <Dropdowns
                  data={orderStatusDrop}
                  onApplySelection={(e) => {
                    setSelectedOrderStatus(e);
                    setPreselectOrderStatus(undefined);
                  }}
                  handleClear={() => {
                    setSelectedOrderStatus([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "status"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={orderStatusOptionToDelete}
                  columnSingleDelete={"status"}
                  preSelectValue={preselectOrderStatus}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {orderTypeDrop ? (
                <Dropdowns
                  data={orderTypeDrop}
                  onApplySelection={(e) => {
                    setSelectedOrderType(e);
                    setPreselectOrderType(undefined);
                  }}
                  handleClear={() => {
                    setSelectedOrderType([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "order_type"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={orderTypeOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectOrderType}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {orderNumber ? (
                <Dropdowns
                  data={orderNumber}
                  onApplySelection={(e) => {
                    setSelectedOrder(e);
                    setPreselectOrder(undefined);
                  }}
                  handleClear={() => {
                    setSelectedOrder([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "order_number"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  preSelectValue={preselectOrder}
                  parameters={dropdownsCompanyParameters}
                  deleteSingleOption={orderOptionToDelete}
                  columnSingleDelete={"id"}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {PRNDrop ? (
                <Dropdowns
                  data={PRNDrop}
                  onApplySelection={(e) => {
                    setSelectedPRN(e);
                    setPreselectPRN(undefined);
                  }}
                  handleClear={() => {
                    setSelectedPRN([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "part_request_number"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={PRNOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectPRN}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {PNDrop ? (
                <Dropdowns
                  data={PNDrop}
                  onApplySelection={(e) => {
                    setSelectedPN(e);
                    setPreselectPN(undefined);
                  }}
                  handleClear={() => {
                    setSelectedPN([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "part_number_list"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={PNOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectPN}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>

            <div>
              {categoryDrop ? (
                <Dropdowns
                  data={categoryDrop}
                  onApplySelection={(e) => {
                    setSelectedCategory(e);
                    setPreselectCategory(undefined);
                  }}
                  handleClear={() => {
                    setSelectedCategory([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "category"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={categoryOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectCategory}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {locationDrop ? (
                <Dropdowns
                  data={locationDrop}
                  onApplySelection={(e) => {
                    setSelectedLocation(e);
                    setPreselectLocation(undefined);
                  }}
                  handleClear={() => {
                    setSelectedLocation([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "location_id"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={locationOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectLocation}
                  optionsSelectedColumnName={"code"}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {sitesDrop ? (
                <Dropdowns
                  data={sitesDrop}
                  onApplySelection={(e) => {
                    setSelectedSites(e);
                    setPreselectSites(undefined);
                  }}
                  handleClear={() => {
                    setSelectedSites([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "site_id"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={sitesOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectSites}
                  optionsSelectedColumnName={"site_code"}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {vendorsDrop ? (
                <Dropdowns
                  data={vendorsDrop}
                  onApplySelection={(e) => {
                    setSelectedVendors(e);
                    setPreselectVendors(undefined);
                  }}
                  handleClear={() => {
                    setSelectedVendors([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "vendor_name"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={vendorsOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectVendors}
                  parameters={dropdownsCompanyParameters}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>

            <div>
              {priorityDrop ? (
                <Dropdowns
                  data={priorityDrop}
                  onApplySelection={(e) => {
                    setSelectedPriority(e);
                    setPreselectPriority(undefined);
                  }}
                  handleClear={() => {
                    setSelectedPriority([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "priority"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={priorityOptionToDelete}
                  columnSingleDelete={"name"}
                  preSelectValue={preselectPriority}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {chapterDrop ? (
                <Dropdowns
                  data={chapterDrop}
                  onApplySelection={(e) => {
                    setSelectedChapter(e);
                    setPreselectChapter(undefined);
                  }}
                  handleClear={() => {
                    setSelectedChapter([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "ata_chapter_ids"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={chapterOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectChapter}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {sectionDrop ? (
                <Dropdowns
                  data={sectionDrop}
                  onApplySelection={(e) => {
                    setSelectedSection(e);
                    setPreselectSection(undefined);
                  }}
                  handleClear={() => {
                    setSelectedSection([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "ata_section_ids"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={sectionOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectSection}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>

            {/*<div>
            {ACDrop ? (
              <Dropdowns
                data={ACDrop}
                onApplySelection={(e) => {
                  setSelectedAC(e);
                  setPreselectAC(undefined);
                }}
                handleClear={() => {
                  setSelectedAC([]);
                  setBody((prev) => {
                    const data = prev.filter(
                      (item) => item.columnName !== "tail_number"
                    );
                    getOrders(0, pageSize, "", sortingOrder, data, false);
                    return data;
                  });
                }}
                deleteSingleOption={ACOptionToDelete}
                columnSingleDelete={"id"}
                preSelectValue={preselectAC}
              ></Dropdowns>
            ) : (
              <></>
            )}
          </div>*/}
            <div>
              {WPDrop ? (
                <Dropdowns
                  data={WPDrop}
                  onApplySelection={(e) => {
                    setSelectedWP(e);
                    setPreselectWP(undefined);
                  }}
                  handleClear={() => {
                    setSelectedWP([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "wp"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={WPOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectWP}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {TCDrop ? (
                <Dropdowns
                  data={TCDrop}
                  onApplySelection={(e) => {

                    setSelectedTC(e);
                    setPreselectTC(undefined);
                  }}
                  handleClear={() => {
                    setSelectedTC([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "tc"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={TCOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectTC}
                  parameters={tcParameters}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {FNDDrop ? (
                <Dropdowns
                  data={FNDDrop}
                  onApplySelection={(e) => {
                    setSelectedFND(e);
                    setPreselectFND(undefined);
                  }}
                  handleClear={() => {
                    setSelectedFND([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "fnd"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={FNDOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectFND}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {supplyChainUserDrop ? (
                <Dropdowns
                  data={supplyChainUserDrop}
                  isStatic={true}
                  onApplySelection={(e) => {
                    //temporaly static to prevent error
                    setSelectedSupplyChainUser(e);
                    setPreselectSupplyChainUser(undefined);
                  }}
                  handleClear={() => {
                    setSelectedSupplyChainUser([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "supply_chain"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={supplyChainUserOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectSupplyChainUser}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>
            <div>
              {AWBDrop ? (
                <Dropdowns
                  data={AWBDrop}
                  isStatic={true}
                  onApplySelection={(e) => {
                    // temporaly static to prevent error
                    setSelectedAWB(e);
                    setPreselectAWB(undefined);
                  }}
                  handleClear={() => {
                    setSelectedAWB([]);
                    setBody((prev) => {
                      const data = prev.filter(
                        (item) => item.columnName !== "awb"
                      );
                      getOrders(0, pageSize, "", sortingOrder, data, false);
                      return data;
                    });
                  }}
                  deleteSingleOption={AWBOptionToDelete}
                  columnSingleDelete={"id"}
                  preSelectValue={preselectAWB}
                ></Dropdowns>
              ) : (
                <></>
              )}
            </div>

            <div
              style={{
                gridColumn: "span 2",
              }}
            >
              <DateRangeComponent
                label="Created Date"
                getDateRange={(e) => {
                  setCreatedDateRange(e);
                }}
                resetRange={resetCreatedDateRange}
              ></DateRangeComponent>
            </div>

            {/* <div
            style={{
              gridColumn: "span 2",
            }}
          >
            <DateRangeComponent
              label="Delivery Date"
              getDateRange={(e) => {
                setDeliveryDateRange(e);
              }}
              resetRange={resetDeliveryDateRange}
            ></DateRangeComponent>
          </div>
          <div
            style={{
              gridColumn: "span 2",
            }}
          >
            <DateRangeComponent
              label="Received Date"
              getDateRange={(e) => {
                setReceivedDateRange(e);
              }}
              resetRange={resetReceivedDateRange}
            ></DateRangeComponent>
          </div>*/}
            {/*  <div>

          </div>*/}
            <div>
              <FormGroup
                sx={{
                  background: "#DFF5EB",
                  border: "1px solid #50D999",
                  borderRadius: "calc(var(--button-radius) - .2rem)",
                  height: "2rem",
                }}
              >
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "calc(var(--p-size) + .1rem)",
                      color: "var(--black-mid)",
                      fontWeight: "400",
                    },
                  }}
                  control={<Checkbox defaultChecked />}
                  label="See All Users Orders"
                />
              </FormGroup>
            </div>
            <button className="orders-clear-filters-btn" onClick={clearFilters}>
              Clear All
            </button>
          </section>
        </section>
        <section className="order-management-content">
          {/* <div className="search-section">
            <p>Orders</p>
            <div style={{
              marginRight: "auto"
            }}>
              <input
                type="text"
                placeholder="Search"
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                value={searchValue}
              />
              {searchValue !== "" &&
                searchValue !== undefined &&
                searchValue !== null ? (
                <i
                  tabIndex={1}
                  style={{
                    cursor: "pointer",
                    fontSize: ".8rem",
                  }}
                  className="icon-cross"
                  onClick={() => {
                    setSearchValue("");
                  }}
                ></i>
              ) : (
                <i
                  style={{
                    cursor: "pointer",
                  }}
                  className="icon-search"
                ></i>
              )}
            </div>

          </div> */}
          <section className="list-order-main-cont">
            <SortingHeader
              valuesExtractor={{
                order_type: (items) => items.map((i) => i.id),
                status: (items) => items.map((i) => i.status),
                order_number: (items) => items.map((i) => i.id),
                location_id: (items) => items.map((i) => i.id),
                site_id: (items) => items.map((i) => i.id),
                priority: (items) => items.map((i) => i.name),
                vendor: (items) => items.map((i) => i.name),
                supply_user: (items) => items.map((i) => i.id),
              }}
              filtersParameters={{
                vendor: dropdownsCompanyParameters,
                order_number: dropdownsCompanyParameters,
              }}
              onFiltersSelected={(newFiltersArray, fullSelectedMap) => {
                handleSortingFiltersChange(fullSelectedMap)
              }}
              showHeaderOrder={true}

            />
            <PermissionsProvider resourceId={20}>
              <OrderManagementProvider>
                <div className="order-list-cont" ref={orderListRef}>
                  {allOrders.length > 0 ? (
                    allOrders.map((item, index) => {
                      return <OrderCards key={item.id} data={item} priceRange={priceRange}
                        isDraft={draftOrders.some((e) => e.id === item.id)}
                        resetParentList={reloadOrders}
                        draftInfo={draftOrders.find((e) => e.id === item.id)}

                      ></OrderCards>;
                    })
                  ) : (
                    <ResultsNotFound></ResultsNotFound>
                  )}
                </div>
              </OrderManagementProvider>
            </PermissionsProvider>
          </section>
        </section>
      </section>
    </SortingProvider>
  );
};
